export default "__VITE_ASSET__8b011407__"